module.exports = __webpack_public_path__ + "h5/img/live-logo.ff32727e.gif";